import { Box, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DrawerContentContainer = styled(Box)(({ alignment = 'center', theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignment,
  gap: theme.spacing(2),
  height: '100%',
  width: '100%',
}));

export const TitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.softGray,
  padding: theme.spacing(1, 2),
  borderRadius: theme.spacing(1),
  width: '100%',
  minHeight: '46px',
  height: 'fit-content',
}));

export const TitleTextField = styled(TextField)(({ theme }) => ({
  width: 'fit-content',
  '& .MuiOutlinedInput-root': {
    margin: 0,
    '& fieldset': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      ...theme.typography.bodyRegular,
      color: theme.colors.gray,
      textAlign: 'right',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      height: 'fit-content',
      width: 'fit-content',
      minWidth: '100px',
    },
  },
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.softGray,

  borderRadius: theme.spacing(1),
  width: '100%',
}));

export const DaysContainer = styled(Box)({
  display: 'flex',
  alignSelf: 'center',
  width: '100%',
  justifyContent: 'space-between',
  gap: '8px',
});

export const DeleteButton = styled(Button)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  color: theme.colors.red,
  width: '100%',
  height: '48px',
  borderRadius: '6px',
  backgroundColor: theme.colors.softGray,
  border: `1px solid ${theme.colors.error}`,
  '&:hover': {
    backgroundColor: theme.colors.error,
    color: theme.colors.white,
  },
}));

export const SaveEventButton = styled(Button)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  width: '100%',
  height: '48px',
  borderRadius: '6px',
  backgroundColor: theme.colors.softGray,
  color: theme.colors.blue,
  '&:hover': {
    backgroundColor: theme.colors.blue,
    color: theme.colors.white,
  },
}));

export const ErrorMessage = styled(Box)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  color: theme.colors.red,
  width: '100%',
  padding: theme.spacing(1),
}));
